// Helper function to generate CSV template
export const generateTemplateCSV = () => {
  const headers = [
    "SR.",
    "Client Name",
    "Client Code",
    "Infinity Code",
    "SR.",
    "Arabic Name",
    "ID Region",
    "Employee Type",
    "Location",
    "National ID",
    "DOB",
    "Age",
    "Gender",
    "Phone number",
    "Emergency Phone Number",
    "Hiring Date",
    "Resigned Date",
    "Resign Reasons",
    "Be-Regular Date",
    "To Be Regular Or Not",
    "working age(year)",
    "working age(month)",
    "Period  for being regular",
    "labor mode",
    "Contract Company",
    "Contract Date",
    "Term of contract",
    "Contract Expiration",
    "beginning date for the insured",
    "Insurance Status",
    "months for insurance",
    "Insurance Number",
    "Insurance Salary",
    "Email",
    "Address",
    "City",
    "Country",
    "Religion",
    "Marital Status",
    "Nationality",
    "Graduate institutions and universities",
    "Major",
    "Graduation year",
    "ID Copy",
    "original copy of Graduation certificate",
    "Original and copy of birth certificate",
    "Original military service certificate",
    "Original labor letter",
    "No crime certificate",
    "6 Photos",
    "uniform size",
    "original copy of Form No.6",
    "Medical Check Form111",
    "Did Medical Check or Not",
    "Original copy of medical examination report",
    "Copy of lawyer's certificate",
    "Copy of driver's license",
    "Copy of Test engineer's certificate",
    "Copy of accountant certificate",
    "Militry Status",
    "Health Certificate For Office Boys",
    "Health Certificate Expiry Date",
    "Health Certificate Still Available or not",
    "Drive license Degree",
    "Driving License Expiry date",
    "Drive.License Still Available",
    "Date of last contract",
    "Term of last contract",
    "Expiration of last contract",
    "Medical Insurance Stage",
    "Delivered",
    "Medical Number",
    "Employee state"
  ];
  // Create 5 empty rows for template
  const rows = Array(5).fill(headers.map(() => ""));

  return [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
};

// Function to generate CSV content from employees data
export const generateCSV = (employees) => {
  // Return empty string if no employees
  if (employees.length === 0) return "";

  // Define CSV headers
  const headers = [
    "Employee ID",
    "Full Name",
    "Email",
    "Phone",
    "Labor Mode",
    "Department",
    "Company",
    "Status",
    // "Salary" intentionally omitted — Manager View never exports salary data.
    "Join Date",
  ];

  // Create CSV rows array starting with headers
  const csvRows = [headers.join(",")];

  // Add employee data rows
  employees.forEach((emp) => {
    // `emp.id` is infinityCode (a String) when set; only falls back to the
    // raw numeric DB id when infinityCode is missing — never export that.
    const row = [
      typeof emp.id === "string" ? emp.id : "N/A",
      `"${emp.name}"`, // Wrap in quotes to handle commas in names
      emp.email,
      emp.phone,
      `"${emp.laborMode}"`,
      `"${emp.department}"`,
      `"${emp.company}"`,
      emp.status,
      emp.joinDate ? new Date(emp.joinDate).toLocaleDateString() : "N/A",
    ];
    csvRows.push(row.join(","));
  });

  // Return CSV content as string
  return csvRows.join("\n");
};

// Function to download CSV file
export const downloadCSV = (csvContent, filename) => {
  // Create blob with CSV content
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  // Create download link
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  // Add to DOM, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
